import set from 'lodash/set';
import unset from 'lodash/unset';
import cloneDeep from "lodash/cloneDeep";

export function SET_IS_BOOTED(state, data) {
	state.isBooted = data;
}

export function SET_S3_URL(state, data) {
	state.s3Url = data;
}

export function SET_SCHOOLS(state, data) {
	state.schools = data;
}

export function SET_FILTER_OPTIONS(state, data) {
	state.filterOptions = data;
}

export function ADD_FILTER(state, filter) {
	let preAppliedFilters = { ...state.preAppliedFilters };

	set(preAppliedFilters, filter.name, filter.value);

	state.preAppliedFilters = { ...{}, ...preAppliedFilters };
}

export function REMOVE_FILTER(state, filter) {
	let preAppliedFilters = { ...state.preAppliedFilters };

	unset(preAppliedFilters, filter);

	state.preAppliedFilters = { ...{}, ...preAppliedFilters };
}

export function SET_IS_LOADING(state, data) {
	state.isLoading = data;
}
export function START_LOADING(state) {
	state.requestCount++;
	state.isLoading = true;
}

export function STOP_LOADING(state) {
  state.requestCount--;
  if (state.requestCount === 0) {
	state.isLoading = false;
  }
}

export function START_APPLYING_QUERY_PARAM_FILTERS(state) {
	state.isApplyingQueryParamFilters = true;
}

export function STOP_APPLYING_QUERY_PARAM_FILTERS(state) {
	state.isApplyingQueryParamFilters = false;
}

export function SET_FILTER_ANCHOR(state, data) {
	state.filterAnchor = data;
}

export function SET_OPEN_FILTER(state, filterPath) {
	state.openFilter = filterPath;
}

export function SET_APPLIED_FILTERS(state, filters) {
	state.appliedFilters = cloneDeep(filters);
	state.preAppliedFilters = cloneDeep(filters);
}

export function RESET_FILTERS(state, filters) {
	state.preAppliedFilters = cloneDeep(filters);
}

export function SET_ACTIVE_LOCATION_FILTER(state, filter) {
	state.activeLocationFilter = filter;
}

export function SET_IS_ZIP_CODE_VALID(state, isValid) {
	state.isZipCodeValid = isValid;
}

export function SELECT_SCHOOL(state, school) {
    state.selectedSchool = school;
}

export function TOGGLE_SCHOOL_SEARCH_MODAL(state, modalData) {
	state.showSchoolSearchModal = modalData ? modalData : {name: '', actions: ''};
}

export function SET_SPORT_POSITIONS_MAP(state, positionsMap) {
  state.positionsMap = positionsMap;
}

export function SET_NEEDS_BY_SCHOOL(state, needsBySchool) {
  state.needsBySchool = needsBySchool;
}